export default {
}



// WEBPACK FOOTER //
// ./src/router/router-config-prod.js